<template>
  <v-card>
    <v-toolbar dark prominent color="primary">
      <v-toolbar-title>Students</v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-slot:extension>
        <v-tabs v-model="tab" background-color="rgb(0,0,205,0.5)">
          <v-tabs-slider color="secondary"></v-tabs-slider>
          <v-tab>My Students</v-tab>
          <v-tab>Print</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <student :students="students"></student>
      </v-tab-item>
      <v-tab-item>
        <print :students="students"></print>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>
<script>
import Student from "../components/Student";
import Print from "../components/Print";

export default {
  components: {
    Student,
    Print,
  },
  data: () => ({
    tab: null,
    students: [],
  }),
  computed: {},
  methods: {
    getStudents() {
      this.filterGrades = [];
      this.$sisApi("get", `my-schedule/students`)
        .then((response) => {
          this.students = response.data;
          this.students.sort(
            (a, b) => (a.full_name_2 > b.full_name_2 && 1) || -1
          );
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
          this.snackbar_text = error.response.data.message;
        });
    },
  },
  mounted() {
    this.getStudents()
  },
};
</script>
